module.exports = __webpack_public_path__ + "static/wedding_1-64b921ad0da19590ed28297169cbf599.jpg";